<div>
  <ul class="list-unstyled mb-0">
    <li class="item">
      <a href="javascript:;" class="itemLink">
        <div class="itemPic bg-success">
          <i class="fe fe-file-text"></i>
        </div>
        <div class="mr-2">
          <div>Payment Received</div>
          <div class="text-muted">3 minutes ago</div>
        </div>
        <div class="itemAction">
          <span></span>
        </div>
      </a>
    </li>
    <li class="item">
      <a href="javascript:;" class="itemLink">
        <div class="itemPic bg-info">
          <i class="fe fe-mail"></i>
        </div>
        <div class="mr-2">
          <div>Message Removed</div>
          <div class="text-muted">2 hours ago</div>
        </div>
        <div class="itemAction">
          <span></span>
        </div>
      </a>
    </li>
    <li class="item">
      <a href="javascript:;" class="itemLink">
        <div class="itemPic bg-danger">
          <i class="fe fe-grid"></i>
        </div>
        <div class="mr-2">
          <div>Parcel Received</div>
          <div class="text-muted">6 hours ago</div>
        </div>
        <div class="itemAction">
          <span></span>
        </div>
      </a>
    </li>
    <li class="item">
      <a href="javascript:;" class="itemLink">
        <div class="itemPic bg-primary">
          <i class="fe fe-database"></i>
        </div>
        <div class="mr-2">
          <div>Parcel Recived</div>
          <div class="text-muted">15 hours ago</div>
        </div>
        <div class="itemAction">
          <span></span>
        </div>
      </a>
    </li>
    <li class="item">
      <a href="javascript:;" class="itemLink">
        <div class="itemPic bg-success">
          <i class="fe fe-flag"></i>
        </div>
        <div class="mr-2">
          <div>User Activated</div>
          <div class="text-muted">2 days ago</div>
        </div>
        <div class="itemAction">
          <span></span>
        </div>
      </a>
    </li>
  </ul>
</div>